import { ENavigationItemSegmentation } from 'core/model/enums/hierarchy.enum';
import {
  ISubitemWithCategoriesType,
  ISubitemWithProductIdsType,
  THierarchyTreeSubitem,
} from 'core/model/interfaces/navigation/hierarchy.interface';

export const getHierarchyAssociation = (body: Omit<THierarchyTreeSubitem, 'id'>) => {
  const { submitemType } = body;
  if (submitemType === ENavigationItemSegmentation.BY_CATEGORIES_AND_FAMILIES) {
    const bodyCategories = body as unknown as ISubitemWithCategoriesType;
    return { productFamilyIds: bodyCategories.families, segmentationTypeId: submitemType };
  }
  if (submitemType === ENavigationItemSegmentation.BY_PRODUCT_IDS) {
    const bodyCategories = body as unknown as ISubitemWithProductIdsType;
    return {
      productIds: bodyCategories.productIds
        ?.split(',')
        .map(ec => ec.trim())
        .filter(ec => ec.trim() !== ''),
      segmentationTypeId: submitemType,
    };
  }
};
